"use client";

import { useEffect, useRef, useState } from "react";

/**
 * 要素がビューポートに入ったタイミングで `inView` を true にする。
 * `once: true` (デフォルト) なら一度入ったら以降ずっと true (フェードインの再現に最適)。
 */
export function useInView<T extends HTMLElement = HTMLDivElement>(
  options: { once?: boolean; rootMargin?: string; threshold?: number } = {}
) {
  const { once = true, rootMargin = "0px 0px -10% 0px", threshold = 0.1 } = options;
  const ref = useRef<T>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (once) obs.unobserve(el);
        } else if (!once) {
          setInView(false);
        }
      },
      { rootMargin, threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [once, rootMargin, threshold]);

  return { ref, inView };
}
